import React, { Component } from 'react';
class PaymentCancelled extends Component {
    state = {  }
    render() { 
        return ( 
            <div style={{textAlign: 'center', margin: '50px'}}>
                <h1><u>Payment Cancelled</u></h1>
                <h4>Your payment has been cancelled and you have not been charged.</h4>
            </div>
         );
    }
}
 
export default PaymentCancelled;